var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHangerNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485",
    style: {
      enableBackground: "new 0 0 485 485"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.205,418.208H59.795C26.824,418.208,0,391.384,0,358.413c0-24.374,14.575-46.096,37.132-55.341L227.5,225.054v-55.4 h15c20.088,0,36.431-16.343,36.431-36.431S262.588,96.792,242.5,96.792s-36.431,16.343-36.431,36.431h-30 c0-36.63,29.801-66.431,66.431-66.431s66.431,29.801,66.431,66.431c0,31.472-22.002,57.904-51.431,64.723v27.107l190.368,78.019 C470.425,312.317,485,334.04,485,358.413C485,391.384,458.176,418.208,425.205,418.208z M242.5,251.328L48.509,330.832 C37.265,335.44,30,346.266,30,358.413c0,16.429,13.366,29.794,29.795,29.794h365.41c16.429,0,29.795-13.366,29.795-29.794 c0-12.147-7.265-22.973-18.509-27.581L242.5,251.328z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHangerNote);
export default __webpack_public_path__ + "static/media/icon-hanger-note.e441ed2beb36b913e811044e8e34a387.svg";
export { ForwardRef as ReactComponent };